var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Header',[_c('div',{attrs:{"slot":"logo"},slot:"logo"},[_c('Logo',{attrs:{"showWhite":true,"title":"竞赛平台"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }